import { styled } from '@mui/system';

export const AnimatedBackgroundRotatingCircle = styled('div')({
  WebkitAnimation: 'rotating 20s linear infinite',
  MozAnimation: 'rotating 20s linear infinite',
  msAnimation: 'rotating 20s linear infinite',
  OAnimation: 'rotating 20s linear infinite',
  animation: 'rotating 20s linear infinite',
  width: '500px',
  height: '500px',
  lineHeight: '100px',
  position: 'absolute',
  color: '#b7b4c7',
  opacity: 0.5,
  filter: 'blur(100px)',
  borderRadius: '40%',
  transformStyle: 'preserve-3d',
  '@keyframes rotating': {
    from: {
      msTransform: 'rotate(0deg)',
      MozTransform: 'rotate(0deg)',
      WebkitTransform: 'rotate(0deg)',
      OTransform: 'rotate(0deg)',
      transform: 'rotate(0deg)',
    },
    to: {
      msTransform: 'rotate(360deg)',
      MozTransform: 'rotate(360deg)',
      WebkitTransform: 'rotate(360deg)',
      OTransform: 'rotate(360deg)',
      transform: 'rotate(360deg)',
    },
  },
  // for Safari and Chrome
  '@-webkit-keyframes rotating': {
    from: {
      WebkitTransform: 'rotate(0deg)',
      OTransform: 'rotate(0deg)',
      transform: 'rotate(0deg)',
    },
    to: {
      WebkitTransform: 'rotate(360deg)',
      OTransform: 'rotate(360deg)',
      transform: 'rotate(360deg)',
    },
  },
});
